import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Flex, Spin } from 'antd';
import { useAuth } from './AuthContext';

/**
 * Authentication guard (client-side, UX only — the server is the source of truth).
 * Use as a layout route; renders child routes via <Outlet /> once authenticated.
 */
export default function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
        <Spin size="large" />
      </Flex>
    );
  }

  if (status !== 'authenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
